import axios from 'axios'
import { ToggleButton } from 'primereact/togglebutton'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import { connect } from 'react-redux'
import { Col, Label, Row } from 'reactstrap'

import { Dropdown } from 'primereact/dropdown'
import CustomEditor from '../../common/CustomEditor'
import InputGroup from '../../common/InputGroup'

import { EMAIL, OUT_GOING_CALL, TEXT_MESSAGE } from '../../constants/activityTypes'
import { FOLLOW_UP_NEXT_WEEK, FOLLOW_UP_PER_POLICY, FOLLOW_UP_TOMORROW } from '../../constants/nextStep'
import { BRANCH_MANAGER, DIRECT_MAIL_ACTIVITIES, MANAGER } from '../../constants/permissions'
import { reminderTypes } from './reminderOptions'

import { getUsersForDropDown } from '../Users/redux/userActions'
import {
  editEventDataFromTask,
  editTaskData,
  getDueDateTask,
  getUserTasksMonthlyStatistic,
  handleDueDate,
  isTaskAssigned,
  isTodayMeetingExists,
  setInitialTaskData,
} from './Redux/taskActions'

import moment from 'moment'
import CustomModal, { useModal } from '../../common/CustomModal/CustomModal'
import CustomSelect from '../../common/CustomReactSelectComponent'
import { AddAttachment } from '../../common/FileAttachment/AddAttachment'
import ReactDatePicker from '../../common/ReactDatePicker/ReactDatePicker'
import { useFileAttachments } from '../../hooks/useFileAttachments'

const TaskForm = ({
  userPermissions,
  getUsersForDropDown,
  usersForCustomSelect,
  setInitialTaskData,
  selectedNextStep,
  taskData,
  editTaskData,
  getDueDateTask,
  userId,
  editEventDataFromTask,
  userData,
  // isEdit,
  isBatchCreation,
  descriptionFromActivity,
  eventData,
  errors,
  contactIdTask,
  setIsTaskAssignedState,
  taskIdEdit,
  isTodayMeetingExists,
  customAssigned,
  customData,
  userMonthlyTaskStatistic,
  getUserTasksMonthlyStatistic,
  isRfpCustomer,
  isMfpCustomer,
  toggleIsRfpCustomer,
  toggleIsMfpCustomer,
  isCreditAppCustomer,
  toggleIsCreditAppCustomer,
  isOnlineFormCustomer,
  toggleIsOnlineFormCustomer,
  displayButton,
}) => {
  const [assigneDisabled, setAssigneDisabled] = useState(false)
  const [options, setOptions] = useState({ ActivityType: [] })
  const [customersForAttendees, setCustomersForAttendees] = useState([])
  const ACTIVITY_SUPPORT_TYPE_ID = 8
  const MEETING_TYPE = 10013
  const [userTaskCountByDate, setUserTaskCountByDate] = useState([])
  const { attachments, isMaxFilesExceeded, onUploadDocuments: onAttachmentUpload, List } = useFileAttachments()
  const { isModalOpen: isAddAttachmentModalOpen, toggleModal: toggleAddAttachmentModal } = useModal()

  const disableMeetingDates = useMemo(() => {
    return true
  }, [])

  useEffect(() => {
    // map unconditionally - a month without tasks has to clear the previous month's counts
    const mappedData = userMonthlyTaskStatistic.map((dayData) => {
      return {
        date: dayData.date,
        value: dayData.count,
      }
    })

    setUserTaskCountByDate(mappedData)
  }, [userMonthlyTaskStatistic])

  useEffect(() => {
    if (attachments) {
      editTaskData('attachments', attachments)
    }
  }, [attachments])

  useEffect(() => {
    if (taskData.selectedActivityType === MEETING_TYPE) {
      // if meeting and no meetingEnd date => reset dueDate
      if (!eventData.meetingEnd) {
        // editTaskData('dueDate', '')
      }
      // if no dueDate and meetingEnd date => set dueDate
      if (!taskData.dueDate && eventData.meetingEnd) {
        editTaskData('dueDate', eventData.meetingEnd)
      }
    }
  }, [taskData.selectedActivityType, eventData.meetingEnd, taskData.dueDate])

  useEffect(() => {
    loadData()
  }, [])

  useEffect(() => {
    if (customData) {
      Object.keys(customData).map((prop) => {
        editTaskData(prop, customData[prop])
      })
    }
  }, [customData])

  const loadData = () => {
    let data = {}
    if (
      selectedNextStep === FOLLOW_UP_PER_POLICY ||
      selectedNextStep === FOLLOW_UP_NEXT_WEEK ||
      selectedNextStep === FOLLOW_UP_TOMORROW
    ) {
      data.title = 'Follow up'
    }
    data.dueDate = handleDueDate({}, selectedNextStep)
    data.description = descriptionFromActivity
    setInitialTaskData(data)
  }

  const handleMonthChange = (date) => {
    getUserTasksMonthlyStatistic(date, userId)
  }

  const handleCalendarOpen = () => {
    let date = null

    if (taskData.dueDate) {
      date = taskData.dueDate
    }

    getUserTasksMonthlyStatistic(date, userId)
  }

  const handleChangeEventData = (e) => {
    if (e.persist) e.persist()
    const { name, value } = e.target

    editEventDataFromTask(name, value)
  }

  const handleChangeEventDate = (date, name) => {
    const value = date ? moment(date).format('MM/DD/YYYY hh:mm a') : ''
    if (name === 'meetingStart') {
      isTodayMeetingExists(value, userId)
    }
    if (name === 'meetingEnd') {
      getDueDateTask(value)
      if (!taskData.dueDate) {
        editTaskData('dueDate', value)
      }
    }
    editEventDataFromTask(name, value)
  }

  const handleChangeSelectEventData = (values, name) => {
    const selectedAttendees = []
    if (values) {
      values.forEach((value) => {
        return selectedAttendees.push(value.value || value.id)
      })
    }
    editEventDataFromTask(name, selectedAttendees)
  }

  const handleChangeTaskDate = (date, name) => {
    const value = date ? moment(date).format('MM/DD/YYYY hh:mm a') : ''
    if (name === 'dueDate') {
      getDueDateTask(value)
    }
    editTaskData(name, value)
  }

  const handleChangeSelect = (e, name) => {
    if (name === 'selectedActivityType') {
      if (e.id === OUT_GOING_CALL) {
        editTaskData('title', 'Call')
      } else if (e.id === TEXT_MESSAGE) {
        editTaskData('title', 'Send Text')
      } else if (e.id === EMAIL) {
        editTaskData('title', 'Send Email')
      }
    }
    editTaskData(name, e.value || e.id)
  }

  const handleChangeEditor = (e) => {
    editTaskData('description', e.htmlValue)
  }

  const setDefaultAssigned = () => {
    if (customAssigned) {
      editTaskData('assigned', customAssigned)
    } else {
      editTaskData('assigned', userId)
    }
  }

  const setIsAssignedError = async (userIdParam) => {
    // skip check on batch creation
    if (userIdParam && !isBatchCreation) {
      const isAssigned = await isTaskAssigned(userIdParam, contactIdTask)
      if (isAssigned.length) {
        setIsTaskAssignedState(true)
      } else {
        setIsTaskAssignedState(false)
      }
    }
  }

  useEffect(() => {
    if (!taskIdEdit) {
      setIsAssignedError(taskData.assigned)
    }
  }, [taskData.assigned])

  useEffect(() => {
    const loadData = async () => {
      const response = await axios.get(
        `/support-types/supportTypesForSelects/?types=${ACTIVITY_SUPPORT_TYPE_ID}&types=7`
      )
      let options = {}
      response.data.map((i) => {
        return (options[i.name.replace(/\s/g, '')] = i.data.filter((d) => d.name !== 'Incoming Call'))
      })
      if (!userPermissions.includes(DIRECT_MAIL_ACTIVITIES)) {
        options = {
          ...options,
          ['ActivityType']: options.ActivityType.filter((i) => {
            return i.name !== 'Direct Mail' || i.name !== 'Incoming Call'
          }),
        }
      }
      setOptions(options)
      // editTaskData('dueDate', new Date())
    }
    if (userData.permissions.includes(MANAGER) || userData.permissions.includes(BRANCH_MANAGER)) {
      setAssigneDisabled(false)
    } else {
      setAssigneDisabled(true)
    }

    const loadUsersForAteendees = async () => {
      const response = await getUsersForDropDown()
      setCustomersForAttendees(response)
    }

    loadData()
    setDefaultAssigned()
    loadUsersForAteendees()
  }, [])

  const activityDropdownOptions = [
    { name: 'Call', code: 'Call' },
    { name: 'Send Email', code: 'Send Email' },
    { name: 'Send Text', code: 'Send Text' },
  ]

  const changeSubject = (e) => {
    if (typeof e.value === 'object') {
      editTaskData('title', e.value.code)
    } else {
      editTaskData('title', e.value)
    }
  }

  const onUploadDocuments = (data) => {
    toggleAddAttachmentModal()
    onAttachmentUpload(data)
  }

  return (
    <>
      <CustomModal
        isOpen={isAddAttachmentModalOpen}
        toggle={toggleAddAttachmentModal}
        headerText='Add Attachment'
        showCloseButton
      >
        <AddAttachment onUploadDocuments={onUploadDocuments} multiple />
      </CustomModal>
      <Row className='mt-1 f-flex align-items-end'>
        <Col xs={12} md={6} lg={6}>
          <Label>Subject</Label>
          <Dropdown
            value={taskData.title}
            options={activityDropdownOptions}
            placeholder='Subject'
            onChange={changeSubject}
            optionLabel='name'
            editable
            className='custom-dropdown'
          />
        </Col>
        {displayButton.rfp && (
          <Col xs={12} md={1} lg={1}>
            <div className='text-center'>
              <Label>RFP</Label>
              <div>
                <ToggleButton checked={isRfpCustomer} onChange={toggleIsRfpCustomer} />
              </div>
            </div>
          </Col>
        )}

        {displayButton.mfp && (
          <Col xs={12} md={1} lg={1}>
            <div className='text-center'>
              <Label>Mexico Freight</Label>
              <div>
                <ToggleButton checked={isMfpCustomer} onChange={toggleIsMfpCustomer} />
              </div>
            </div>
          </Col>
        )}
        {displayButton.creditApp && (
          <Col xs={12} md={1} lg={1}>
            <div className='text-center'>
              <Label>Credit App</Label>
              <div>
                <ToggleButton checked={isCreditAppCustomer} onChange={toggleIsCreditAppCustomer} />
              </div>
            </div>
          </Col>
        )}

        {displayButton.onlineForm && (
          <Col xs={12} md={1} lg={1}>
            <div className='text-center'>
              <Label>Online Form</Label>
              <div>
                <ToggleButton checked={isOnlineFormCustomer} onChange={toggleIsOnlineFormCustomer} />
              </div>
            </div>
          </Col>
        )}
        <Col xs={12} md={2} lg={2}>
          <div className='text-center'>
            <Label>High Priority</Label>
            <div>
              <ToggleButton checked={taskData.priority} onChange={() => editTaskData('priority', !taskData.priority)} />
            </div>
          </div>
        </Col>
        <Col xs={12} md={3} lg={3}>
          <CustomSelect
            isMulti={false}
            label='Assigned'
            disabled={assigneDisabled}
            placeholder='Please Select...'
            onChange={(e) => handleChangeSelect(e, 'assigned')}
            defaultValue={taskData.assigned || null}
            options={usersForCustomSelect}
          />
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col xs={12} md={3} lg={3}>
          {/* <CustomDataPicker
            placeholder='mm/dd/yyyy'
            disabled={taskData.selectedActivityType === MEETING_TYPE || taskData.activityType === MEETING_TYPE}
            showTime
            show12Time
            name='dueDate'
            label='Due Date/Time'
            onChange={handleChange}
            value={displayDate(taskData.dueDate, 'MM/DD/YYYY hh:mm A')}
            errorMess={errors.dueDate ? errors.dueDate : ''}
          /> */}
          <ReactDatePicker
            onMonthChange={handleMonthChange}
            onCalendarOpen={handleCalendarOpen}
            additionalDayContentData={userTaskCountByDate}
            selected={taskData.dueDate ? new Date(taskData.dueDate) : ''}
            errorMess={errors.dueDate ? errors.dueDate : ''}
            onChange={(date) => handleChangeTaskDate(date, 'dueDate')}
            label='Due Date'
            showTimeSelect
            showTimeInput
            isClearable
            placeholder='mm/dd/yyyy'
            // disabled={taskData.selectedActivityType === MEETING_TYPE || taskData.activityType === MEETING_TYPE}
          />
        </Col>
        <Col xs={12} md={4} lg={4}>
          <CustomSelect
            isMulti={false}
            label='Activity Type'
            placeholder='Please select...'
            onChange={(e) => handleChangeSelect(e, 'selectedActivityType')}
            defaultValue={taskData.selectedActivityType || taskData.activityType || null}
            options={options.ActivityType}
          />
        </Col>
        <Col xs={12} md={3} lg={3}>
          <CustomSelect
            isMulti={false}
            label='Remind Me'
            placeholder='Please Select...'
            onChange={(e) => handleChangeSelect(e, 'reminder')}
            defaultValue={taskData.reminder}
            options={reminderTypes}
          />
        </Col>
      </Row>
      {(taskData.selectedActivityType === MEETING_TYPE || taskData.activityType === MEETING_TYPE) && (
        <Row className='mt-3'>
          <Col xs={12} md={3} lg={3}>
            <InputGroup
              label='Location'
              name='location'
              value={eventData.location}
              onChange={(e) => handleChangeEventData(e)}
            />
          </Col>
          {!disableMeetingDates && (
            <>
              <Col xs={12} md={3} lg={3}>
                <ReactDatePicker
                  selected={eventData.meetingStart ? new Date(eventData.meetingStart) : ''}
                  errorMess={errors.meetingStart ? errors.meetingStart : ''}
                  onChange={(date) => handleChangeEventDate(date, 'meetingStart')}
                  label='Meeting Start Date/Time'
                  showTimeSelect
                  showTimeInput
                  isClearable
                  placeholder='mm/dd/yyyy'
                />
              </Col>
              <Col xs={12} md={3} lg={3}>
                <ReactDatePicker
                  selected={eventData.meetingEnd ? new Date(eventData.meetingEnd) : ''}
                  errorMess={errors.meetingEnd ? errors.meetingEnd : ''}
                  onChange={(date) => handleChangeEventDate(date, 'meetingEnd')}
                  label='Meeting End Date/Time'
                  showTimeSelect
                  showTimeInput
                  isClearable
                  placeholder='mm/dd/yyyy'
                />
              </Col>
            </>
          )}

          <Col xs={12} md={3} lg={3}>
            <CustomSelect
              isMulti
              label='Attendees'
              placeholder='Attendees'
              onChange={(e) => handleChangeSelectEventData(e, 'attendees')}
              defaultValue={eventData.attendees || []}
              options={customersForAttendees || []}
            />
          </Col>
        </Row>
      )}
      <Row className='mt-5'>
        <Col xs={12} md={12} lg={12}>
          <CustomEditor
            disableAttachmentButton={isMaxFilesExceeded}
            addAttachmentClick={toggleAddAttachmentModal}
            onChange={handleChangeEditor}
            value={taskData.description}
            height='250px'
            customStyle={{ backgroundColor: 'none' }}
          />
        </Col>
      </Row>
      <Row>
        <Col>{List}</Col>
      </Row>
    </>
  )
}

TaskForm.propTypes = {
  userPermissions: PropTypes.array.isRequired,
  getUsersForDropDown: PropTypes.func.isRequired,
  usersForCustomSelect: PropTypes.array,
  userId: PropTypes.number.isRequired,
  setInitialTaskData: PropTypes.func.isRequired,
  taskData: PropTypes.object,
  editTaskData: PropTypes.func.isRequired,
  getDueDateTask: PropTypes.func.isRequired,
  editEventDataFromTask: PropTypes.func.isRequired,
  eventData: PropTypes.object,
}

TaskForm.defaultProps = {
  usersForCustomSelect: [],
  taskData: { selectedActivityType: 10013 },
  eventData: {},
}

const mapStateToProps = (state) => {
  return {
    errors: state.errors,
    userPermissions: state.auth.user.permissions,
    userId: state.auth.user.userId,
    userData: state.auth.user,
    usersForCustomSelect: state.users.usersForDropDown,
    taskData: state.Task.data,
    eventData: state.Task.eventDataFromTask,
    userMonthlyTaskStatistic: state.Task.monthlyStatistic,
  }
}

export default connect(mapStateToProps, {
  getUsersForDropDown,
  setInitialTaskData,
  editTaskData,
  getDueDateTask,
  editEventDataFromTask,
  isTodayMeetingExists,
  getUserTasksMonthlyStatistic,
})(TaskForm)
